import React, {useContext, useRef} from 'react';
import IconButton from "../common/IconButton";
import { UserIcon, ChevronDownIcon } from "../common/icons";
import { UserContext } from "../common/UserContext";
import NavigationMenu from "./NavigationMenu";
import ListItem from "../common/ListItem";
import {BrandContext} from "../common/BrandContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";

const UserDropdown = props => {
    const { user } = useContext(UserContext);
    const buttonRef = useRef();
    const { visible, handleClick, handleClose } = props;
    const brandConfig = useContext(BrandContext);

    const handleOpen = () => {
        handleClick({shortcutId: 'userDropdown'})
    }

    const { loadShortcutByUrl } = useCurrentShortcut();

    const handleSelect = (urlOrAction) => {
        if (typeof urlOrAction === 'string') {
            loadShortcutByUrl(urlOrAction);
        } else if (typeof urlOrAction === 'function') {
            urlOrAction();
        }
        handleClose();
        const main = document.querySelector('main');
        if (main) main.focus();
    };

    return(
        <div className={'ch-nav-icon-btn'}>
            <IconButton
                className={'ch-title-user'}
                onClick={handleOpen}
                ref={buttonRef}
                aria-label={'User settings'}
                aria-expanded={visible ? 'true' : 'false'}
                aria-controls={'user-settings-dropdown'}
            >
                <UserIcon />
                <span className={'ch-title-user-name'}>{user.firstName}</span>
                <ChevronDownIcon />
            </IconButton>
            <NavigationMenu visible={visible} callback={handleClose} parent={buttonRef.current} menuWidget={false}>
                <ul className={'ch-list'} id={'user-settings-dropdown'}>
                    <ListItem
                        isDisclosureItem={true}
                        onClick={() => handleSelect('/web/ui/view/accountSettings')}
                        style={{ width: '100%' }}
                        url={'#'}
                    >
                        Account Settings
                    </ListItem>

                    {brandConfig.brandCode !== 'USA' && (
                        <ListItem isDisclosureItem={true} onClick={() => handleSelect(openEditUserTimeZoneDialog)}>
                           Time Zone
                        </ListItem>
                    )}

                    <ListItem
                        isDisclosureItem={true}
                        onClick={() => handleSelect('/controlCentre/userLogout.action')}
                        style={{ width: '100%' }}
                        url={'#'}
                    >
                        Log Out
                    </ListItem>
                </ul>
            </NavigationMenu>
        </div>
    )
}

export default UserDropdown;